import { render, staticRenderFns } from "./NoPollsFound.vue?vue&type=template&id=0500a2bf&scoped=true&"
import script from "./NoPollsFound.vue?vue&type=script&lang=ts&"
export * from "./NoPollsFound.vue?vue&type=script&lang=ts&"
import style0 from "./NoPollsFound.vue?vue&type=style&index=0&id=0500a2bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500a2bf",
  null
  
)

export default component.exports